import { FETCH_ERROR } from "@boark/shared/consts/fetch-error";
import { useQuery } from "@tanstack/react-query";

import { getContract, getContracts } from "../services/contract";

export function useGetContracts() {
  return useQuery({
    queryKey: ["contracts"],
    queryFn: () => getContracts(),
    staleTime: 1000 * 60,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetContract(id: string) {
  return useQuery({
    queryKey: ["contract", id],
    queryFn: () => getContract(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
